import React, { useState } from "react";

// 電子報訂閱區元件
const Newsletter = ({ t }) => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <section className="newsletter">
      <div className="container">
        <h2>{submitted ? "🎉" : t.newsletter.title}</h2>
        {submitted ? (
          <p style={{ color: "#00d46a", fontWeight: 600, fontSize: 18 }}>
            Subscribed successfully!
          </p>
        ) : (
          <>
            <p>{t.newsletter.description}</p>
            <form className="newsletter-form" onSubmit={handleSubmit}>
              <input
                type="email"
                placeholder={t.newsletter.placeholder}
                required
              />
              <button type="submit">{t.newsletter.button}</button>
            </form>
          </>
        )}
      </div>
    </section>
  );
};

export default Newsletter;
